import { GasSettingsView } from "@vaporfi/features";
import type React from "react";
import { useGasPriceManager } from "state/user/hooks";

export const GasSettings: React.FC = () => {
	const [gasPrice, setGasPrice] = useGasPriceManager();

	return <GasSettingsView gasPrice={gasPrice} setGasPrice={setGasPrice} />;
};
